import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

import Header from '../Header';
import useLocalStorage from '../../hooks/useLocalStorage';
import { ModalContext } from '../../context';
import settings from '../../config';
import { format } from '../../utils';
import editIcon from '../../imgs/edit.png';
import deleteIcon from '../../imgs/delete.png';
import tShirtIcon from '../../imgs/t-shirt.svg';

const FabricCuts = () => {
  const [fabricTransactions, setFabricTransactions] = useState([]);
  const { fabricId } = useParams();
  const [admin] = useLocalStorage('admin');
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}fabric/transactions`, {
        fabricId,
        transactionType: -1
      });

      if (response.data.statusCode === 200) {
        setFabricTransactions(response.data.data);
      }
    })();
  }, [fabricId]);

  const deleteFabricTransaction = async (fabricTransactionId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}fabric/delete-transaction`,
          {
            fabricTransactionId
          }
        );

        if (response.data.statusCode === 200) {
          setFabricTransactions(
            fabricTransactions.filter(
              (fabricTransaction) =>
                fabricTransactionId !== fabricTransaction.fabricTransactionId
            )
          );
        }
      }
    });
  };

  return (
    <div className='w-full'>
      <Header text='قص الخام' link={`/fabric/cut/form/${fabricId}`} />
      <table className='w-full table-auto border-separate border-spacing-1 text-right '>
        <thead>
          <tr>
            <th>مسلسل</th>
            <th>اسم الخامه</th>
            <th>الوزن</th>
            <th>تاريخ القص</th>
            <th className='text-center w-24'>تركيب</th>
            {admin.canEdit === 1 && <th className='text-center w-24'>تعديل</th>}
            {admin.canDelete === 1 && <th className='text-center w-24'>حذف</th>}
          </tr>
        </thead>
        <tbody>
          {fabricTransactions.map((fabricTransaction) => {
            return (
              <tr
                key={fabricTransaction.fabricTransactionId}
                className='bg-white odd:bg-gray-100 hover:bg-orange-100'
              >
                <td>{fabricTransaction.fabricTransactionId}</td>
                <td>{fabricTransaction.fabricName}</td>
                <td>
                  {(fabricTransaction.weight || 0).toLocaleString('en-US')}
                </td>
                <td>{fabricTransaction.transactionDate}</td>
                <td className='text-center'>
                  <Link
                    to={`/fabric/variants/${fabricTransaction.fabricTransactionId}`}
                    className='flex flex-col items-center w-full cursor-pointer'
                  >
                    <img src={tShirtIcon} alt='edit' className='h-8' />
                  </Link>
                </td>
                {admin.canEdit === 1 && (
                  <td className='text-center'>
                    <Link
                      to={`/fabric/cut/form/${fabricId}/${fabricTransaction.fabricTransactionId}`}
                      className='flex flex-col items-center w-full cursor-pointer'
                    >
                      <img src={editIcon} alt='edit' className='h-10' />
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className='text-center'>
                    <div
                      className='flex flex-col items-center w-full cursor-pointer'
                      onClick={() =>
                        deleteFabricTransaction(
                          fabricTransaction.fabricTransactionId
                        )
                      }
                    >
                      <img src={deleteIcon} alt='delete' className='h-5' />
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FabricCuts;
